const HERO_IMG = "/images/main.png";
const HERO_IMG_MOBILE = "/images/mobile-background.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full bg-ivory overflow-hidden"
    >
      {/* Main image — full bleed, contains the band logo. Mobile uses a portrait-friendly crop. */}
      <div className="absolute inset-0">
        <picture>
          <source media="(max-width: 767px)" srcSet={HERO_IMG_MOBILE} />
          <img
            src={HERO_IMG}
            alt="A Wider Horizon — sumi-e ink-wash landscape with a lone figure overlooking the sunrise"
            className="w-full h-full object-contain object-top md:object-cover md:object-center select-none"
            draggable={false}
          />
        </picture>
        {/* gentle ivory wash on the bottom edge for a soft transition into the next section */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "linear-gradient(to bottom, rgba(247,244,235,0) 70%, rgba(247,244,235,0.55) 92%, rgba(247,244,235,1) 100%)",
          }}
        />
      </div>

      {/* Hero CTAs anchored at the bottom of the hero */}
      <div className="relative z-10 flex flex-col justify-end min-h-screen pb-16 md:pb-20 lg:pb-24 px-6 md:px-12 lg:px-20">
        <div className="mx-auto max-w-[1400px] w-full">
          <div className="reveal flex flex-wrap items-center gap-x-6 gap-y-4">
            <a
              data-testid="hero-cta-listen"
              href="#music"
              className="inline-flex items-center text-[11px] uppercase tracking-[0.24em] text-ivory bg-ink hover:bg-teal px-7 py-3.5 transition-colors"
            >
              Watch &amp; Listen
            </a>
            <a
              data-testid="hero-cta-bio"
              href="#about"
              className="inline-flex items-center text-[11px] uppercase tracking-[0.24em] text-ink hover:text-gold transition-colors px-2 py-3.5 link-underline"
            >
              Read the bio
            </a>
          </div>
        </div>
      </div>

      {/* scroll cue */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-2">
        <span className="text-[10px] uppercase tracking-[0.32em] text-ash">
          Scroll
        </span>
        <div className="w-px h-10 bg-ash/50" />
      </div>
    </section>
  );
}
